export default __webpack_public_path__ + "img/d2aed4ac9fecec593b1b2aa68eaf2699.svg";